import { useEffect, useState } from 'react'
import { getUserData } from 'helpers/Auth'

const UseProfile = () => {
 // get from session
 const userProfileSession = getUserData()
 const tokenSession = userProfileSession ? userProfileSession.token : null
 // create statement
 const [userProfile, setUserProfile] = useState(userProfileSession ? userProfileSession : null)
 const [token, setUserToken] = useState(tokenSession)
 // watch changes
 useEffect(() => {
 const userProfileSession = getUserData()
 const tokenSession = userProfileSession ? userProfileSession.token : null

 setUserProfile(userProfileSession ? userProfileSession : null)
 setUserToken(tokenSession)
 }, [])

 return { userProfile, token }
}

export { UseProfile }
